import type {IApplicationRequest} from "./interfaces/IApplicationRequest";
import type {IApplication} from "@/stores/ApplicationStore/interfaces/IApplication";
import type {IApplicationStore} from "./interfaces/IApplicationStore";
import type {TApplicationStoreDefinition} from "./types/TApplicationStoreDefinition";

import {useCrudStore} from "@/stores/CrudStore/CrudStore";

export const useApplicationStore = () =>
    useCrudStore<IApplication, IApplication, IApplicationRequest, TApplicationStoreDefinition, IApplicationStore>({
        storeId: 'applicationStore',
        route: '/portal/{guid}/apps',
        initialize: true,
        langSection: 'stores.application',
        transformItem: (item) => {
            if (typeof item.valid_from === 'string') {
                item.valid_from = new Date(item.valid_from);
            }
            if (typeof item.valid_until === 'string') {
                item.valid_until = new Date(item.valid_until);
            }
            if (Array.isArray(item.permissions)) {
                item.permissions = item.permissions.map((p: any) =>
                    typeof p === 'object' && p !== null ? p.use_case_id : p
                );
            }
            return item;
        },
    });
